import React from 'react';
import { sliceOrNodeToMarkdown } from '../../../config-items/slice-or-node-to-markdown';
import { createEditorPluginAIConfigItemMarkdown } from '../../../config-items/config-items';
import { generate, generateConvoAI } from '../../../provider/prompt-requests/generate';
import { createInsertAtCurrentPosition, createInsertAtTop, createReplaceExistingConfluenceTitle } from '../../config-item-actions/markdown';
import { messages } from './messages';
import { isMinLength } from '../../config-item-visible/visibility-utils';
import { getSlice } from '../utils';
import { Icon } from '../../assets/icons/suggestTitle';
import { getBooleanFF } from '@atlaskit/platform-feature-flags';
const SELECTION_TYPE = 'range';
export const suggestConfigItem = createEditorPluginAIConfigItemMarkdown({
  title: ({
    formatMessage
  }) => formatMessage(messages.title),
  description: ({
    formatMessage
  }) => formatMessage(messages.description),
  selectionType: SELECTION_TYPE,
  getInitialContext: ({
    editorView,
    positions,
    intl,
    updateIdMap
  }) => {
    const selection = sliceOrNodeToMarkdown({
      slice: getSlice(editorView, positions),
      intl,
      editorView,
      convertTo: 'markdown',
      updateIdMap,
      selectionType: SELECTION_TYPE
    });
    const document = sliceOrNodeToMarkdown({
      node: editorView.state.doc,
      intl,
      editorView,
      convertTo: 'markdown',
      updateIdMap,
      selectionType: SELECTION_TYPE
    });
    return {
      selection: selection.markdown,
      document: document.markdown,
      userLocale: intl.locale,
      intentSchemaId: 'suggest_title_intent_schema.json',
      contentStatistics: selection.contentStatistics
    };
  },
  triggerPromptRequest({
    initialContext,
    editorSchema
  }) {
    if (getBooleanFF('platform.editor.ai-assistance-service-suggest-title')) {
      return generateConvoAI({
        userLocale: initialContext.userLocale,
        intentSchemaId: initialContext.intentSchemaId,
        editorSchema,
        currentSelection: initialContext.selection,
        fullDocument: initialContext.document
      });
    }
    return generate({
      userLocale: initialContext.userLocale,
      intentSchemaId: initialContext.intentSchemaId,
      editorSchema,
      contextList: [{
        type: 'text',
        entity: initialContext.selection,
        relationship: 'SELECTION'
      }]
    });
  },
  isVisible: ({
    editorView,
    positions
  }) => isMinLength({
    editorView,
    minLength: 1,
    positions
  }),
  icon: ({
    shownAt
  }) => /*#__PURE__*/React.createElement(Icon, {
    shownAt: shownAt
  }),
  actions: [createInsertAtCurrentPosition({
    appearance: 'secondary'
  }), createInsertAtTop({
    appearance: 'primary'
  })]
});

/**
 * EXPERIMENTAL: Util for experimental flow where 'Suggest title' in
 * Confluence title toolbar will trigger the 'Suggest a title' flow in Editor AI.
 */
export const suggestConfigItemForConfluenceTitleToolbar = createEditorPluginAIConfigItemMarkdown({
  title: ({
    formatMessage
  }) => formatMessage(messages.title),
  description: ({
    formatMessage
  }) => formatMessage(messages.description),
  selectionType: 'range',
  getInitialContext: ({
    editorView,
    positions,
    intl,
    updateIdMap
  }) => {
    const {
      markdown,
      contentStatistics
    } = sliceOrNodeToMarkdown({
      slice: getSlice(editorView, positions),
      intl,
      editorView,
      convertTo: 'markdown',
      updateIdMap,
      selectionType: 'range'
    });
    return {
      selection: markdown,
      userLocale: intl.locale,
      intentSchemaId: 'suggest_title_intent_schema.json',
      contentStatistics
    };
  },
  triggerPromptRequest({
    initialContext,
    editorSchema
  }) {
    return generate({
      userLocale: initialContext.userLocale,
      intentSchemaId: initialContext.intentSchemaId,
      editorSchema,
      contextList: [{
        type: 'text',
        entity: initialContext.selection,
        relationship: 'SELECTION'
      }]
    });
  },
  isVisible: ({
    editorView,
    positions
  }) => isMinLength({
    editorView,
    minLength: 1,
    positions
  }),
  icon: ({
    shownAt
  }) => /*#__PURE__*/React.createElement(Icon, {
    shownAt: shownAt
  }),
  actions: [createReplaceExistingConfluenceTitle({
    appearance: 'primary'
  })]
});